import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { Link } from '@remix-run/react'
import { SmallTitle, Info } from '../text/Text'
import { classNames } from '~/utils/client/helpers'

export type SubPageHeaderProps = {
  icon?: any
  title: string | React.ReactNode
  description?: string | React.ReactNode
  wikiUrl?: string
  wikiText?: string | React.ReactNode
  className?: string
}

export const SubPageHeader = ({
  title,
  icon: IconComponent,
  description,
  wikiUrl = '',
  className,
  wikiText,
}: SubPageHeaderProps) => {
  return (
    <div className={classNames('mb-6', className)}>
      <div className="flex flex-col md:flex-row justify-between md:items-center">
        <div className="flex items-center">
          {IconComponent && (
            <div className="p-2 bg-white rounded-lg mr-2 sm:mr-4">
              <IconComponent className="h-4 text-brand"></IconComponent>
            </div>
          )}
          <SmallTitle id="section-my-depots">{title}</SmallTitle>
        </div>
        {wikiText && (
          <Link to={wikiUrl}>
            <div className="flex items-center md:pl-4">
              <InformationCircleIcon className="w-4 text-accent" />
              <Info className="py-2 md:py-0 pl-2 hover:text-accent">{wikiText}</Info>
            </div>
          </Link>
        )}
      </div>
      {description && <p className="mt-2 text-sm text-body">{description}</p>}
    </div>
  )
}
